import { api } from './client'
import type { FriendsListResponse, LibraryResponse, Theme } from '@/types'

export function setFriendNickname(friendId: string, nickname: string | null): Promise<void> {
  return api.put<void>(`/users/me/friends/${friendId}/nickname`, { nickname })
}

export function fetchFriends(): Promise<FriendsListResponse> {
  return api.get<FriendsListResponse>('/users/me/friends')
}

export function refreshFriends(): Promise<{ syncedAt: string }> {
  return api.post<{ syncedAt: string }>('/users/me/friends/refresh')
}

export function fetchLibrary(): Promise<LibraryResponse> {
  return api.get<LibraryResponse>('/users/me/library')
}

export function refreshLibrary(): Promise<{ syncedAt: string; gameCount: number }> {
  return api.post<{ syncedAt: string; gameCount: number }>('/users/me/library/refresh')
}

export function refreshWishlist(): Promise<{ syncedAt: string; count: number; isPrivate: boolean }> {
  return api.post<{ syncedAt: string; count: number; isPrivate: boolean }>(
    '/users/me/wishlist/refresh',
  )
}

export function setChangelogLastSeen(version: string): Promise<void> {
  return api.put<void>('/users/me/changelog-last-seen', { version })
}

export function setUserTheme(theme: Theme): Promise<void> {
  return api.put<void>('/users/me/theme', { theme })
}
